module.exports = __webpack_public_path__ + "60f8f158539619aaf544fa35ce8daccd.js";